import { render, staticRenderFns } from "./CategoryStepEdit.vue?vue&type=template&id=685e53f4&scoped=true&"
import script from "./CategoryStepEdit.vue?vue&type=script&lang=js&"
export * from "./CategoryStepEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685e53f4",
  null
  
)

export default component.exports